import I18n from 'i18n-js';
import _get from 'lodash/get';
import { ORDER_ID_PARAM_NAME } from '../../constants/endpoints';
import {
  FAQ_ITEMS_LIST,
  FAQ_QUESTIONS_PREFIX,
} from '../../constants/language-translations';

const buildEndpointWithParams = (endpoint, params) => {
  const url = new URL(endpoint);

  const searchParams = url.searchParams;
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  return url.href;
};

/**
 * Used to construct the endpoint by checking the stage and adding the guid
 * @param {string} guid
 */

export const getDynamicEndpointURL = (guid, params) => {
  const { endpoints } = window.Grab.config;
  const hashNumber = _get(params, 'hashNumber');
  const version = _get(params, 'version');
  const { dynamicTracking } = endpoints;

  const result = buildEndpointWithParams(dynamicTracking, {
    [ORDER_ID_PARAM_NAME]: guid,
    utype: hashNumber,
    version,
  });

  return result;
};

export const getFullRequestEndpointURL = (guid, params) => {
  const { endpoints } = window.Grab.config;
  const hashNumber = _get(params, 'hashNumber');
  const version = _get(params, 'version');
  const { staticTracking } = endpoints;

  const result = buildEndpointWithParams(staticTracking, {
    [ORDER_ID_PARAM_NAME]: guid,
    utype: hashNumber,
    version,
  });

  return result;
};

/**
 * Specialized method somewhere between selector and constant
 * @see faq-view.jsx
 * @return {title:String, content:String}
 */
export const getFaqsStringsFromKeyList = () =>
  FAQ_ITEMS_LIST.map(item => ({
    title: I18n.t(`${FAQ_QUESTIONS_PREFIX}.${item}.title`),
    content: I18n.t(`${FAQ_QUESTIONS_PREFIX}.${item}.content`),
  }));
